import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { notesService } from '../services/notesService';

// Async thunks for API calls
export const createNote = createAsyncThunk(
  'notes/createNote',
  async (noteData, { rejectWithValue }) => {
    try {
      const response = await notesService.createNotes(noteData);
      return response.data? response.data : response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchNotesByEntity = createAsyncThunk(
  'notes/fetchNotesByEntity',
  async ({ entityType, entityId }, { rejectWithValue }) => {
    try {
      const response = await notesService.getNotesByEntityTypeAndEntityId(entityType, entityId);
      return response.data? response.data : response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const searchNotes = createAsyncThunk(
  'notes/searchNotes',
  async (params, { rejectWithValue }) => {
    try {
      const response = await notesService.searchNotes(params);
      return response.data? response.data : response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Slice
const notesSlice = createSlice({
  name: 'notes',
  initialState: {
    notes: [],
    searchResults: [],
    searchPagination: null,
    searchMetadata: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearNotes: (state) => {
      state.notes = [];
    },
    clearSearchResults: (state) => {
      state.searchResults = [];
      state.searchPagination = null;
      state.searchMetadata = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Create note
      .addCase(createNote.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNote.fulfilled, (state, action) => {
        state.loading = false;
        state.notes.unshift(action.payload);
      })
      .addCase(createNote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch notes by entity
      .addCase(fetchNotesByEntity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotesByEntity.fulfilled, (state, action) => {
        state.loading = false;
        state.notes = action.payload;
      })
      .addCase(fetchNotesByEntity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Search notes
      .addCase(searchNotes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchNotes.fulfilled, (state, action) => {
        state.loading = false;
        state.searchResults = action.payload.data || action.payload;
        state.searchPagination = action.payload.pagination || null;
        state.searchMetadata = action.payload.metadata || null;
      })
      .addCase(searchNotes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearNotes, clearSearchResults } = notesSlice.actions;
export default notesSlice.reducer;